import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import SummaryPreviewCommon, { SummaryPreviewParams } from '@common/component/templates/SummaryPreviewCommon';
import Layout from '../Layout';

const SummaryPreview: React.FC<RouteComponentProps<SummaryPreviewParams>> = ({ match }) => {
  const { customerId, scrollTargetType, id } = match.params;

  return (
    <Layout isLoggedIn={true}>
      <SummaryPreviewCommon
        defaultViewportMetaContent={''} // 代理店モジュールでは画像参照を行わないため、ブランクをセットします
        userScalableViewportMetaContent={''} // 代理店モジュールでは画像参照を行わないため、ブランクをセットします
        customerId={customerId}
        scrollTargetInfo={
          scrollTargetType && id
            ? {
                scrollTargetType: scrollTargetType,
                id: id,
              }
            : undefined
        }
      />
    </Layout>
  );
};

export default SummaryPreview;
